import React from "react";
import { styled } from "../stitches.config";
import { observer } from "mobx-react";

import Header from "./Article/Header";
import HardcoverImageBanner from "./Article/Parts/Hardcover/HardcoverImageBanner"
import { useStores } from "../helpers/useStores"
import Link from "./Link"

import HardcoverLogo from "./HardcoverLogo"

const ArticleHardcover = observer(() => {
    const { ArticleStore: { article } } = useStores();

    return (
        <ArticleHardcoverWrap>
            <ColumnLeft>
                <HardcoverImageBanner blockData={article.TitlePart[0]?.data} />
                <HardcoverLogoMobile />
            </ColumnLeft>
            <ColumnRight>
                <Title>{article.title}</Title>
                <Author rel="author" to={article.author.url}>{article.author.name}</Author>
                <Date>{article.display_date}</Date>
                <Header article={article} />
            </ColumnRight>
        </ArticleHardcoverWrap>
    );
})

const ArticleHardcoverWrap = styled("div", {
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 992px)": {
        flexDirection: "row",
        flexGrow: 1
    }
});

const Title = styled("h1", {
    fontSize: "28px",
    fontFamily: "'Source Serif Pro', serif",
    borderBottom: "2px solid",
    paddingBottom: "23px",
    margin: "30px 35px 24px",
    maxWidth: "calc(100vw - 70px)",
    "@media (min-width: 992px)": {
        fontSize: "32px",
        margin: "30px 115px 24px"
    }
});

const Author = styled(Link, {
    display: "block",
    fontSize: "17px",
    color: "$hardcoverColor",
    textDecoration: "none",
    fontFamily: "$grotesk",
    margin: "0 auto 12px 35px",
    "&:hover": {
        color: "$hardcoverColor"
    },
    "@media (min-width: 992px)": {
        fontSize: "18px",
        margin: "0 auto 12px 115px"
    }
});

const Date = styled("time", {
    fontSize: "12px",
    display: "block",
    marginLeft: "35px",
    marginBottom: "25px",
    color: "#8e8d8d",
    fontFamily: "$grotesk",
    "@media (min-width: 992px)": {
        marginLeft: "115px"
    }
});

const ColumnLeft = styled("div", {
    backgroundColor: "#161616",
    maxWidth: "100vw",
    paddingBottom: "30px",
    marginTop: "56px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&>img:first-of-type": {
        borderRadius: "30px",
        boxShadow: "0px 0px 20px #000000",
        margin: "30px"
    },
    "@media (min-width: 992px)": {
        width: "48%",
        height: "calc(100vh - 56px)",
        position: "fixed",
        zIndex: 16,
        "&>img:first-of-type": {
            margin: "60px 58px"
        }
    }
});

const HardcoverLogoMobile = styled(HardcoverLogo, {
    "@media (min-width: 992px)": {
        display: "none"
    }
});

const ColumnRight = styled("div", {
    margin: "0 auto",
    'div[class*="ImageWrapper"]': {
        width: "100%"
    },
    "@media (min-width: 992px)": {
        marginTop: "58px",
        width: "52%",
        marginLeft: "48%",
        'div[class*="ImageWrapper"]': {
            width: "calc(100% - 230px)"
        }
    }
});

export default ArticleHardcover